import api from './api';

/**
 * Trusted Feed API service
 * Calls /api/feed/* endpoints on the server
 */

// Get portfolio summary (total locations, regions, metrics)
export const getFeedSummary = async () => {
  const response = await api.get('/api/feed/summary');
  return response.data;
};

// Get all regions
export const getRegions = async () => {
  const response = await api.get('/api/feed/regions');
  return response.data;
};

// Get locations with optional filters
export const getLocations = async (params = {}) => {
  const response = await api.get('/api/feed/locations', { params });
  return response.data;
};

// Get single location by ID
export const getLocation = async (id) => {
  const response = await api.get(`/api/feed/locations/${id}`);
  return response.data;
};

// Get reviews for a location
export const getLocationReviews = async (id, params = {}) => {
  const response = await api.get(`/api/feed/locations/${id}/reviews`, { params });
  return response.data;
};

// Get posts for a location
export const getLocationPosts = async (id, params = {}) => {
  const response = await api.get(`/api/feed/locations/${id}/posts`, { params });
  return response.data;
};

// Get admins/access for a location
export const getLocationAdmins = async (id) => {
  const response = await api.get(`/api/feed/locations/${id}/admins`);
  return response.data;
};

const feedApi = {
  getFeedSummary,
  getRegions,
  getLocations,
  getLocation,
  getLocationReviews,
  getLocationPosts,
  getLocationAdmins,
};

export default feedApi;
